<template>
  <div class="picked h-auto flex flex-col items-center justify-start p-6">
    <div class="w-full flex flex-wrap">
      <h2 class="w-full mb-3">Palette</h2>
      <div v-if="palette.colors.length < 6" class="w-1/2">
        <div
          class="flex items-center mb-4 text-2xl text-grey-light
          hover:bg-grey-lightest cursor-pointer"
          v-on:click="addToPalette"
          v-bind:style="{ color: `hsl(${picked.h}, ${picked.s}%, ${picked.l}%)` }"
        >
          <div
            class="h-24 w-24 flex items-center justify-center rounded-full flex-shrink-0 mr-4"
            v-bind:style="{ background: `hsl(${picked.h}, ${picked.s}%, ${picked.l}%)`}"
          >
            <font-awesome-icon icon="plus" class="text-white text-4xl svg-shadow" />
          </div>
          <p class="m-0 ml-4 text-xl leading-none">Add To Palette</p>
        </div>
      </div>
      <PaletteColor
        v-for="(color, key) in palette.colors"
        :key="key"
        :color="color"
        @edit="$emit('edit', { ...color })"
        @copy="$emit('copy', color)"
        @remove="$emit('remove', key)"
      />
    </div>
    <div
      class="flex justify-around p-6"
      style="box-sizing: border-box;"
    >
      <v-button
        v-if="palette.colors.length > 0"
        :click="savePalette"
        text="Save New Palette"
      ></v-button>
    </div>
  </div>
</template>

<script>
import Button from './Button.vue';
import PaletteColor from './PaletteColor.vue';

export default {
  name: 'PaletteBuilder',
  props: [
    'picked',
    'palette',
  ],
  components: {
    'v-button': Button,
    PaletteColor,
  },
  methods: {
    border(lightness, key) {
      let classes = '';
      classes = classes + (lightness === this.picked.l) ? 'border-0' : 'border-8';
      classes = classes + (key > 0) ? 'border-l-8' : '';
      return classes;
    },
    addToPalette() {
      this.$emit('add', { h: this.picked.h, s: this.picked.s, l: this.picked.l });
    },
    savePalette() {
      this.$emit('save');
    },
  },
};
</script>
